import { map } from 'rxjs/operators';
import { PlatformLocation, CommonModule } from '@angular/common';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CropperOption } from 'ngx-cropper';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { CommonValues } from 'src/app/services/commonValues';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { CustomValidator } from '../../Helper/custom-validator';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { GlobalCommunity } from '../../../services/globalCommunity.service';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSummernoteModule } from 'ngx-summernote';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


declare var $: any;
@Component({
  selector: 'app-community-profile',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgSelectModule, NgxSummernoteModule, CommonSkeletonComponent, ImageCropperModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './community-profile.component.html',
  styleUrls: ['./community-profile.component.scss']
})
export class CommunityProfileComponent extends FormValidation implements OnInit {
  @ViewChild("myFileInput") myFileInput;
  @ViewChild("myFileInput1") myFileInput1;
  @ViewChild("lgModal") lgModal;
  @ViewChild("lgModal1") lgModal1;
  tagSelectedItems: any = [];
  viewadmin
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  basicForm: UntypedFormGroup
  communityId: any = "";
  businessId: any;
  placeholder: any = "Add more";
  secondaryPlaceholder: any = "Option to add 3 #Tags"
  aboutForm: UntypedFormGroup
  aboutCommunity: any;
  tagLine: any;
  communityType: any;
  public FORMERROR = super.Form;
  banner: any;
  industryClass: any;
  facilityFlag: boolean = false;
  facilityPracticeType: any;
  companyType: any;
  yearStarted: any;
  members: any;
  tags: any;
  communityName: any;
  guidelineForm: UntypedFormGroup
  guidelines: any;
  submit: boolean
  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true
  }
  amsubmit :boolean= false;
  fileUploadName: any = '';
  fileUploadNamebanner: any = '';
  croppedImage: any = '';
  photoWindow = true;
  public cropperConfig: CropperOption;
  fileToUpload: File;
  fileToUploadbanner: File;
  photoIdbanner: any
  photoId: any;
  img: any;
  data: any;
  information: any;
  clickEventsubscription: Subscription;
  loadAPIcall:boolean=false;
  values: any = {}
  items: any = [];
  imageChangedEvent: any = '';
  imageChangedEventbanner: any = '';
  isAdmin
  isSuperAdmin


  memberslength

  object: any = []
  communityhome
  patchurldata
  modelhide = false
  charCountEmitter: Subscription;


  remainingCount: any;
  remainingGuidelinesCount: any;
  @Input() commonemit
  changeName: any;
  communityGuidelines: any;

  constructor(private modalService: BsModalService,
    private fb: UntypedFormBuilder,
    private commonvalues: CommonValues,
    private router: Router,
     private api: ApiService,
    private gigsumoService: GigsumoService,
    private route: ActivatedRoute,
    private util: UtilService,
    private platform: PlatformLocation,
    private globalcommunity: GlobalCommunity) {
      super();
    this.items = Array(15).fill(0);
    this.clickEventsubscription = this.commonvalues.getbusinessid().subscribe((res) => {
      this.values = res;
      this.isAdmin = localStorage.getItem('isAdmin');
      this.isSuperAdmin = localStorage.getItem('isSuperAdmin');

      if (this.isSuperAdmin) {
        this.isAdmin = this.isSuperAdmin
      }

    })




    this.platform.onPopState(() => this.modalRef.hide());
    this.platform.onPopState(() => this.modalRef2.hide());


    this.charCountEmitter = this.commonvalues.getCharCount().subscribe(res=>{
      this.remainingCount = res.value
      this.remainingGuidelinesCount = res.guidelinesCountValue
    });

    this.route.queryParams.subscribe((res) => {
      this.patchurldata = res;
      this.communityId = res.communityId;

    });
  }

  ngOnInit() {

    this.values = this.commonemit;

    this.communitydetailsapicall();

    this.tagSelectedItems = [];
    this.basicForm = this.fb.group({
      communityName: [null, [Validators.required, Validators.maxLength(100)]],
      tagLine: [null, [Validators.maxLength(140)]],
      communityType: [false],
      banner: [null],
      bannerimg: [null],
      tags: [null],
    })
     this.aboutForm = this.fb.group({
      aboutCommunity: [
        '',
        Validators.compose([
          this.companyMinMaxCharacters(this.PITCH.min, this.ABOUT_YOURSELF.max),
        ]),
      ],
    });
    this.aboutForm.get('aboutCommunity')?.valueChanges.subscribe((value) => {
      this.amsubmit=false
      this.updateRemainingCharacters('aboutYourself', value || '');
    });
    this.guidelineForm = this.fb.group({
      communityGuidelines: [
        '',
        Validators.compose([
          this.companyMinMaxCharacters(this.PITCH.min, this.COMMUNITY_ME.max),
        ]),
      ],
    });
    this.guidelineForm.get('communityGuidelines')?.valueChanges.subscribe((value) => {
      this.amsubmit=false
      this.updateRemainingCharacters('community', value || '');
    });

  }




  communitydetailsapicall() {

    let data = this.communityId;
    this.loadAPIcall = true;
    this.util.startLoader();
    this.api.query('community/details/' + data).subscribe(res => {

      this.loadAPIcall=false;
      if(res.code === GigsumoConstants.SUCESSCODE){

          this.data = res.data.communityDetails;
          this.fetchData();

          this.memberslength = res.data.communityDetails.memberCnt;
          if(res.data.communityDetails.tagLine==null){
            res.data.communityDetails.tagLine=""
          }

          this.commun()
          let data: any = {}
          data.communityId = res.data.communityDetails.communityId;
          data.userId = localStorage.getItem('userId')
          this.api.create('community/home', data).subscribe(res1 => {
            this.communityhome = res1.data;
          });

      }

      this.util.stopLoader();
    },err => {
      this.util.stopLoader();
    })


  }

  commun() {
    this.yearStarted = this.data.yearStarted
  }
  grabData() {
    this.route.queryParams.subscribe((data) => {
      this.communityId = data.communityId
    })
  }

  acquireData() {
    if (this.information.industryClassification == "MEDICAL_HEALTHCARE_PRACTICE") {
      this.industryClass = "Medical/ Healthcare Practice"
    }
    this.facilityPracticeType = this.information.facilityPracticeType
    this.companyType = this.information.companyType
    this.yearStarted = this.information.yearStarted
    this.members = this.information.yearStarted

  }

  validate() {
   this.loadAPIcall=true;
    this.api.query('community/details/' + this.communityId).subscribe(response => {
      this.loadAPIcall=false
      this.util.stopLoader()
      this.data = response.data.communityDetails;
      this.globalcommunity.setCommunityBannerData(response.data.communityDetails);
      console.log(this.globalcommunity.communityBannerDetails);

      this.fetchData();
    },err => {
      this.util.stopLoader();
    })


    if (this.businessId != undefined || this.businessId != null) {
      this.api.query('business/details/' + this.businessId).subscribe(response => {

        this.information = response.data.businessModelList[0];

        this.acquireData()
      },err => {
        this.util.stopLoader();
      })

    }
  }

  decline1(){
    this.lgModal.hide()
  }

  fetchData() {
    this.aboutCommunity = this.data.aboutCommunity
    if (this.data.communityType == true) {
      this.communityType = "Private"
    } else if (this.data.communityType == false) {
      this.communityType = "Public"
    }
    this.communityName = this.data.communityName
    this.tagLine = this.data.tagLine
    this.banner = this.data.banner
    this.guidelines = this.data.communityGuidelines
    this.tags = this.data.tags
    this.communityName = this.data.communityName
  }


  changetype(value: any, $event) {
    this.changeName = value;
    this.basicForm.get('communityType').patchValue(value === "Public" ? false : true);
  }

  editBasic(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.backdropConfig);

    this.basicForm.patchValue(this.data);

    this.tagSelectedItems = []
    if (this.data.tags != undefined &&
      this.data.tags != null &&
      this.data.tags != '') {
      this.data.tags.forEach(ele => {
        this.tagSelectedItems.push(ele)
      })

    }

    if (this.data.logo != undefined && this.data.logo != null && this.data.logo != "") {
      this.photoId = this.data.logo
    }


  }
  reloadpage() {

    let data: any = {}
    data.communityId = this.patchurldata.communityId
    data.communityName = this.basicForm.value.communityName
    data.menu = "communityabout"

    this.router.navigate(['community'], { queryParams: data })

    setTimeout(() => {
      this.router.navigate(['community'], { queryParams: data })
      const queryParams: Params = {};
      this.router.navigate([],{
         relativeTo: this.route,
         queryParams: queryParams,
         queryParamsHandling: 'merge',
       });

    }, 400);




  }
  cancel() {

    this.modalRef.hide();

  }

  updateCommmunity(){
        this.modalRef.hide();
        this.data.communityName = this.basicForm.value.communityName
        this.data.tagLine = this.basicForm.value.tagLine
        this.data.communityType = this.basicForm.value.communityType
        this.data.yearStarted = this.yearStarted
        this.data.tags = this.basicForm.value.tags
        // this.data.aboutCommunity = this.data.aboutCommunity;

        if (this.photoId != undefined && this.photoId != null && this.photoId != "") {
          this.data.logo = this.photoId
        } else {
          this.data.logo = this.data.logo
        }
        if (this.photoIdbanner != undefined) {
          this.data.banner = this.photoIdbanner
        } else {
          this.data.banner = this.data.banner
        }
        this.object = []
        this.basicForm.value.tags.forEach(ele => {
          if (ele['label']) {
            this.object.push(ele['label'])
          } else {
            this.object.push(ele)
          }
        })

        this.data.tags = this.object;
        this.data.members = [];
        if (this.basicForm.valid) {
          this.util.startLoader();

          this.api.updatePut('community/update', this.data).subscribe(res => {
            if (res.code == "00000") {
              this.photoId = undefined;
              this.photoIdbanner = undefined;

              // The post feed reads the community logo from GigsumoService's
              // per-community cache, which was only emptied on logout — so a new
              // picture stayed stale on Community Posts until a full page refresh.
              // Drop the cached entry, then signal live listeners to re-read, exactly
              // as updateAbout() and updateGuidelines() below already do.
              this.gigsumoService.invalidateCommunityDetails(this.data?.communityId || this.communityId);
              var obj: any = {}
              obj.boolean = true
              this.commonvalues.setCommuityBoolean(obj)

              setTimeout(() => {
                this.util.stopLoader();
                this.validate();
              }, 500);

            } else if (res.code == "99999") {
              Swal.fire('Community Name Already Exits', 'info');
            } else if (res.code == 'null') {
              this.photoId = undefined;
              this.photoIdbanner = undefined;
              this.communityName = this.basicForm.value.communityName;
              this.tagLine = this.basicForm.value.tagLine;
              this.communityType = this.basicForm.value.communityType;
              this.banner = this.basicForm.value.banner;
              this.tags = this.basicForm.value.tags;
              this.reloadpage();
            }
          },err => {
            this.util.stopLoader();
          });

        }
  }

  updateBasic() {


    if (this.basicForm.valid) {

      if(this.data.communityType && this.basicForm.value.communityType === false){
          Swal.fire({
            title: 'Do you want to save the changes?',
            showDenyButton: true,
            allowEscapeKey: false,
            text: "Changing community type from private to public .\n All the pending member requests will be added to community members.",
            allowOutsideClick: false,
            confirmButtonText: `Yes`,
            denyButtonText: `No`,
          }).then(res =>{

            if(res.isConfirmed){
              this.updateCommmunity();
            }
            else{
              return;
            }

        });
      }
      else{
        this.updateCommmunity();
      }
    }
  }

getConfig(): any {
  return {
    focus: false,
    height: 150,
    link: [["link", ["linkDialogShow", "unlink"]]],
    insert: ["link", "picture", "video"],
    view: ["fullscreen", "codeview", "help"],
    style: "outline: none !important;background-color: rgb(241 243 246) !important;cursor: pointer !important;",
    disableDragAndDrop: true,
    blockquoteBreakingLevel: 1,
    callbacks: {
      onFocus: function (contents) {
        if ($(this).summernote("isEmpty")) {
          $("#summessage").html("");
        }
      },
      onKeydown: (e) => {
        const text = e.currentTarget.innerText;
        this.updateRemainingCharacters(text);
      },
      onPaste: (e) => {
        const buffertext = (e.originalEvent || e).clipboardData.getData("text");
        e.preventDefault();
        const limitedText = buffertext.slice(0, 10000);  // ✅ Fix: No .join() needed
        document.execCommand("insertText", false, limitedText);
        this.updateRemainingCharacters(limitedText);
      },
    },
    toolbar: [
      ["misc", ["codeview", "undo", "redo"]],
      ["font", ["bold", "italic", "underline", "strikethrough", "superscript", "subscript", "clear"]],
      ["fontsize", ["fontname", "fontsize", "color"]],
      ["para", ["style", "ul", "ol", "paragraph", "height"]],
    ],
    fontNames: ["Helvetica", "Arial", "Arial Black", "Comic Sans MS", "Courier New", "Roboto", "Times"],
  };
}
config2: any = {};
  editAbout(template: TemplateRef<any>) {
    this.config2 = {
      ...this.getConfig(),
      placeholder: 'Brief About  Community',
    };
     this.modalRef = this.modalService.show(template, this.backdropConfig)
    this.aboutForm.patchValue({
      aboutCommunity: this.data.aboutCommunity
    })
  }

  updateAbout() {
    this.aboutForm.markAllAsTouched();
    const cleanedValue = this.aboutForm.controls.aboutCommunity.value
    .replace(/<(p|div|span)>\s*(<br>)?\s*<\/\1>/g, '')
    .replace(/<br\s*\/?>/g, '')
    .replace(/&nbsp;/g, '')
    .replace(/<[^>]+>/g, '')
    .trim();
  this.amsubmit = !cleanedValue;
  if (this.aboutForm.valid && cleanedValue) {
    const cleanedContent = cleanedValue.replace(/<img[^>]*>/g, '');
    this.data.aboutCommunity = cleanedContent;
    this.data.members = []
      this.util.startLoader()
      this.api.updatePut('community/update', this.data).subscribe(res => {
        this.util.stopLoader()
        if (res.code == "00000") {
          var obj: any = {}
          obj.boolean = true
          this.commonvalues.setCommuityBoolean(obj)
          this.aboutCommunity = res.data.community.aboutCommunity
          this.communityId = res.data.community.communityId
          this.aboutForm.patchValue({
            aboutCommunity: res.data.community.aboutCommunity
          })
          this.validate()
        }
      },err => {
        this.util.stopLoader();
      });
       this.modalRef.hide();
    }
  }

  updateGuidelines() {
    this.guidelineForm.markAllAsTouched();
    const cleanedValue = this.guidelineForm.controls.communityGuidelines.value
    .replace(/<(p|div|span)>\s*(<br>)?\s*<\/\1>/g, '')
    .replace(/<br\s*\/?>/g, '')
    .replace(/&nbsp;/g, '')
    .replace(/<[^>]+>/g, '')
    .trim();
  this.amsubmit = !cleanedValue;

     if (this.guidelineForm.valid && cleanedValue) {
    const cleanedContent = cleanedValue.replace(/<img[^>]*>/g, '');
    this.data.communityGuidelines = cleanedContent;
    this.data.members = [];
      this.util.startLoader()
      this.api.updatePut('community/update', this.data).subscribe(res => {
        this.util.stopLoader()
        if (res.code == "00000") {
          var obj: any = {}
          obj.boolean = true
          this.commonvalues.setCommuityBoolean(obj)
          this.guidelines = this.guidelineForm.value.communityGuidelines
          this.validate()
        } else if (res.code == "99999") {

        }
      },err => {
        this.util.stopLoader();
      });
      this.modalRef.hide();
    }
  }
  editGuidelined(template: TemplateRef<any>) {
    this.config2 = {
      ...this.getConfig(),
      placeholder: 'Community Guidelines',
    };

    this.modalRef = this.modalService.show(template, this.backdropConfig);

    this.guidelineForm.patchValue({
      communityGuidelines: this.data.communityGuidelines
    });
  }


  get aboutControl() {
    return this.aboutForm.controls
  }

  get guidelineControls() {
    return this.guidelineForm.controls
  }

  get basicControls() {
    return this.basicForm.controls
  }

  fileChangeEvent(event, popupName): void {
    this.imageChangedEvent = event;
    if (event.target.files && event.target.files[0]) {
      this.fileUploadName = event.target.files[0].name;
      $("#communityLogo").val
       const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
      if (!acceptedImageTypes.includes(event.target.files[0].type)) {
        Swal.fire('', 'Please upload the correct file type   (Only .jpg, .png, .jpeg)', 'info');
        this.myFileInput1.nativeElement.value = "";
        this.modalRef.hide();
      } else {
        this.PopupServicevlaues(popupName);
      }

    } else {
      $("#communityLogo").val("");
    }
  }

  fileChangeEventbanner(event, popupName): void {
    this.imageChangedEventbanner = event;
    if (event.target.files && event.target.files[0]) {
      this.fileUploadNamebanner = event.target.files[0].name;
      $("#communityBanner").val
       const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
      if (!acceptedImageTypes.includes(event.target.files[0].type)) {
        Swal.fire('', 'Please upload the correct file type   (Only .jpg, .png, .jpeg)', 'info');
        this.modalRef.hide();
      } else {
        this.PopupServicevlaues(popupName);
      }
    } else {
      $("#communityBanner").val("");
    }
  }

  PopupServicevlaues(template: TemplateRef<any>) {
    this.modalRef2 = this.modalService.show(template, {
      animated: true,
      backdrop: 'static'
    });
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    //// //// console.log("this.v-- "+this.croppedImage.name);
    //// //// console.log("this.croppedImage-- "+this.croppedImage);

    const byteString = window.atob(event.base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, ''));
    // const byteString = window.atob(event.base64);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });

    this.fileToUpload = new File([blob], this.fileUploadName, { type: 'image/jpeg' });

  }


  imageCroppedBanner(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    //// //// console.log("this.v-- "+this.croppedImage.name);
    //// //// console.log("this.croppedImage-- "+this.croppedImage);

    const byteString = window.atob(event.base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, ''));
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });

    this.fileToUploadbanner = new File([blob], this.fileUploadNamebanner, { type: 'image/jpeg' });

  }

  modalclose() {
    // for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
    //   this.modalService.hide(i);
    // }
    this.modalRef.hide()
  }
  closeModal(): void {
    this.aboutForm.reset();
    this.aboutForm.markAsPristine();
    this.aboutForm.markAsUntouched();
    this.modalService.hide(1);
    this.amsubmit = false;
  }
  closeguidelineModal(){
    this.guidelineForm.reset();
    this.guidelineForm.markAsPristine();
    this.guidelineForm.markAsUntouched();
    this.modalService.hide(1);
    this.amsubmit = false;
  }

  closeImage() {
    this.fileUploadName = undefined;
    this.modalRef2.hide();
    this.img.src = AppSettings.ServerUrl + 'download/' + this.photoId;
    $("#communityLogo").val("")
  }

  closeBannerImage() {
    this.fileUploadName = undefined;
    this.modalRef2.hide();
    // this.img.src = AppSettings.ServerUrl + 'download/' + this.photoId;
    $("#communityBanner").val("")
  }

  imageLoaded() {
    const formData: FormData = new FormData();
    formData.append('file', this.fileToUpload, this.fileUploadName);
    this.util.startLoader()
    this.api.create('upload/image', formData).subscribe(res => {
      this.util.stopLoader()
      this.photoId = res.fileId;
      this.modalRef2.hide()
      //$("#communityLogo").val("")
      this.img = {
        src: AppSettings.ServerUrl + 'download/' + this.photoId
      }
    },err => {
      this.util.stopLoader();
      if(err.status==500){
      this.util.stopLoader();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: 'Something went wrong while uploading image. Please, try again later.',
        showDenyButton: false,
        confirmButtonText: `ok`,
      })
    }
  });
  }

  imageLoadedbanner() {
    const formData: FormData = new FormData();
    if(this.fileToUploadbanner){
      formData.append('file', this.fileToUploadbanner, this.fileUploadNamebanner);
    }
    this.util.startLoader()
    this.api.create('upload/image', formData).subscribe(res => {
      this.util.stopLoader()
      this.photoIdbanner = res.fileId;
      // this.modalclose();
      this.modalRef2.hide()
      //$("#communityBanner").val("")
    },err => {
      this.util.stopLoader();
      if(err.status==500){
      this.util.stopLoader();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: 'Something went wrong while uploading image. Please, try again later.',
        showDenyButton: false,
        confirmButtonText: `ok`,
      })
    }
  });
  }

  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  // getCommunityId(communityId,admin){

  ////   //// console.log(communityId,admin)
  //   this.values.communityId=communityId;
  //   this.values.admin=admin;
  //   this.communityId=communityId;
  //   if(this.values.adminviewnavigation){
  //    this.values.viewadmin=true
  //  }
  //   this.commonvalues.businessid(this.values)
  // }


  getbussinessId(communityId, admin) {

    this.values.communityId = communityId;
    this.values.admin = admin;
    this.communityId = communityId;
    if (this.values.adminviewnavigation) {
      this.values.viewadmin = true;
      this.viewadmin = true;
    }
    this.commonvalues.businessid(this.values)
  }



}
